import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BasePageUAM from '../BasePageUAM/BasePageUAM';
import LoginPanel from './Panels/LoginPanel/LoginPanel';

const LoginUAMPage = ({ brand, destPath }) => {
  return (
    <BasePageUAM
      activeTab={1}
      brand={brand}
      destPath={destPath}
      needsDestPath={true}
      >
        <LoginPanel destPath={destPath} />
    </BasePageUAM>
  );
};

LoginUAMPage.propTypes = {
  brand: PropTypes.object.isRequired,
  destPath: PropTypes.object.isRequired,
};

export default LoginUAMPage;
